
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import moment from 'moment';
  import { Actions } from '@/store/enums/StoreEnums';
  import { RegisteredTradesFilterInfo } from '@/store/modules/RegisteredTrades/RegisteredTradesModule';
  import {
    StatusNotes,
    StatusNotesMap,
  } from '@/views/manage/registered-trades/status-notes.enum';
  import { TradeStatusMap } from '@/views/manage/registered-trades/status-map.enum';

  import Multiselect from '@vueform/multiselect';

  export default defineComponent({
    components: {
      Multiselect,
    },
    name: 'registered-trades-filter',
    emit: ['filter-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const govs = computed(() => store.getters.allListGov);

      const selectedItems = ref<RegisteredTradesFilterInfo>({
        dateFrom: '',
        dateTo: '',
        areaId: '',
        priceFrom: undefined,
        priceTo: undefined,
        size: undefined,
        noteAr: '',
        propertyStatusId: '',
        propertyTypeId: '',
        shortPropertyTypeId: '',
        propertyGroupingId: '',
        statusIds: [],
        statusNotesId: '',
        selectedGov: [],
      });

      const statusOptions = Object.entries(TradeStatusMap).map(
        ([label, value]) => ({ value, label })
      );

      const statusNoteMap = StatusNotesMap;

      const registeredDescs = computed(() => store.getters.getRegisteredDesc);

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = () => {
        if (selectedItems.value.dateFrom) {
          selectedItems.value.dateFrom = moment(
            selectedItems.value.dateFrom
          ).format('YYYY-MM-DD');
        }
        if (selectedItems.value.dateTo) {
          selectedItems.value.dateTo = moment(
            selectedItems.value.dateTo
          ).format('YYYY-MM-DD');
        }
        emit('filter-selected', { ...selectedItems.value });
      };

      const onReset = () => {
        selectedItems.value = {
          dateFrom: '',
          dateTo: '',
          areaId: '',
          priceFrom: undefined,
          priceTo: undefined,
          size: undefined,
          noteAr: '',
          propertyStatusId: '',
          propertyTypeId: '',
          shortPropertyTypeId: '',
          propertyGroupingId: '',
          statusNotesId: '',
          statusIds: [],
          selectedGov: [],
        };
        emit('reset', { ...selectedItems.value });
      };

      onMounted(async () => {
        await store.dispatch(Actions.GET_ALL_AREAS_LIST, {
          type: 'registeredTrades',
        });
        await store.dispatch(Actions.GET_ALL_PROPERTY_TYPE, {
          type: 'registeredTrades',
        });
        await store.dispatch(Actions.GET_ALL_REGISTERED_TRADES_GROUPINGS);
        await store.dispatch(Actions.GET_REGISTERED_TRADES_ASSETS, 6);
        await store.dispatch(Actions.GET_SHORT_PROPERTY_TYPE);
        await store.dispatch(Actions.GET_ALL_GOV_LIST);
      });

      return {
        areas: computed(() => store.getters.allListAreas),
        propertyTypes: computed(() => store.getters.propertyTypesAllList),
        shortPropertyTypes: computed(
          () => store.getters.shortPropertyTypesAllList
        ),
        propertyGroupings: computed(
          () => store.getters.allListRegisteredTradesGroupings
        ),
        registeredDescs,
        selectedItems,
        translate,
        onSubmit,
        onReset,
        statusNoteMap,
        StatusNotes,
        statusOptions,
        govs,
      };
    },
  });
